// ── MoneyStatusBadge ──────────────────────────────────────────────────────────
// Unified status badge for transactions, payouts, invoices, and receipts.

interface MoneyStatusBadgeProps {
  status: string;
}

const STATUS_CLASSES: Record<string, string> = {
  // Transaction statuses
  Succeeded: "bg-green-100 text-green-700",
  Failed: "bg-red-100 text-red-700",
  Refunded: "bg-yellow-100 text-yellow-700",
  Voided: "bg-muted text-muted-foreground",
  Incomplete: "bg-muted text-muted-foreground",
  // Payout statuses
  paid: "bg-green-100 text-green-700",
  in_transit: "bg-blue-100 text-blue-700",
  pending: "bg-muted text-muted-foreground",
  failed: "bg-red-100 text-red-700",
  canceled: "bg-muted text-muted-foreground",
  // Invoice statuses
  Paid: "bg-green-100 text-green-700",
  Sent: "bg-blue-100 text-blue-700",
  Draft: "bg-muted text-muted-foreground",
  Cancelled: "bg-muted text-muted-foreground",
  // Receipt statuses
  sent: "bg-green-100 text-green-700",
  // "pending" and "failed" already defined above
};

const STATUS_LABELS: Record<string, string> = {
  in_transit: "In transit",
  paid: "Paid",
  sent: "Sent",
  Draft: "Draft",
  Cancelled: "Cancelled",
};

export function MoneyStatusBadge({ status }: MoneyStatusBadgeProps) {
  // eslint-disable-next-line security/detect-object-injection -- controlled enum status values
  const classes = STATUS_CLASSES[status] ?? "bg-muted text-muted-foreground";
  // eslint-disable-next-line security/detect-object-injection -- controlled enum status values
  const label = STATUS_LABELS[status] ?? status;

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${classes}`}
    >
      {label}
    </span>
  );
}
